enum CustomLocalizationType {
  STATE = 'STAC',
  CLEANING_MODE = 'CLMO',
  ERROR_CODE = 'ERRC',
  MAINTENANCE_CODE = 'MAIC',
  WARNING_CODE = 'WARC',
  MISSION_START_STOP_REASON = 'MSSR',
  ACTION_DISABLE_REASON = 'ACDR',
}

export default CustomLocalizationType;
